import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { 
  Navigation, 
  Pagination, 
  A11y,  
  Autoplay, 
  EffectCoverflow, 
  EffectFade, 
  EffectFlip, 
  EffectCreative 
} from 'swiper/modules';
import { Box } from '@mui/material';

// Importa gli stili di Swiper
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import "swiper/css/effect-coverflow";
import "swiper/css/effect-fade";
import "swiper/css/effect-flip";
import "swiper/css/effect-creative";
import '../App.css';

interface ImageSliderProps {
  images: string[];
  effect?: 'slide' | 'fade' | 'coverflow' | 'flip' | 'creative';
}

const ImageSlider: React.FC<ImageSliderProps> = ({ images, effect = 'slide' }) => {
  return (
    <Box 
      className="my-custom-slider"
      sx={{ 
        width: '100%',
        '--swiper-navigation-color': '#fff',
        '--swiper-pagination-color': '#fff',
        '--swiper-navigation-size': '22px'
      }}
    >
      <Swiper
        modules={[
          Navigation, 
          Pagination, 
          A11y, 
          Autoplay, 
          EffectCoverflow, 
          EffectFade, 
          EffectFlip, 
          EffectCreative
        ]}
        spaceBetween={10}
        slidesPerView={1}
        navigation
        pagination={{ clickable: true }}
        loop={true}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        }}
        effect={'flip'}
        style={{ borderRadius: '16px' }}
      >
        {images.map((image, index) => (
          <SwiperSlide key={index}>
            <img
              src={image}
              alt={`Slide ${index + 1}`}
              style={{
                width: '100%',
                height: '250px',
                objectFit: 'cover',
                display: 'block',
                borderRadius: '16px',
              }}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </Box>
  );
};

export default ImageSlider;
